import { create, v, w } from '@dojo/framework/core/vdom';
// import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Accordion, AccordionChild } from '@holmescorp/base-widgets/accordion2';
import { Icon } from '@holmescorp/base-widgets/icon';
import { difference, intersection } from '@holmescorp/collections';
import { TopicsetBody } from './topicset-body';
import { TopicsetShortdesc } from './topicset-shortdesc';

import { lccstate, keymap, tapaneChangeProcess, viewEditProcess, createNlsMiddleware } from 'lcc-state';
import { TopicAttrs } from 'lcc-state/interfaces';
// import { subscribe, publish } from '@holmescorp/pub-sub';
import { TopicProperties } from '../interfaces';

import css from '../css/topicaccordion.m.css';

export interface TopicAccordionProperties extends TopicProperties {}

const nls = createNlsMiddleware('settings');
const factory = create({ theme, nls, lccstate }).properties<TopicAccordionProperties>();

export const TopicAccordion2 = factory(({ properties, middleware: { theme, nls, lccstate } }) => {
	const {
		topic: { attributes = {} as TopicAttrs, children = [] }
	} = properties();
	const { key } = attributes;
	const {
		isPlaceholder,
		messages: { is_demo = false, demo_allowed_topics = '[]' }
	} = nls();
	if (isPlaceholder) {
		return null;
	}
	const { get, path } = lccstate;
	const expandKey: string[] = get(path('accordionSelected'));
	const keybase = new Set<string>(expandKey);
	const keylocal = new Set<string>();

	const themeCss = theme.classes(css);

	let allowed_topics: string[] = [];
	try {
		allowed_topics = JSON.parse(demo_allowed_topics);
	} catch (e) {
		console.warn(`json parse error ${e}`, demo_allowed_topics);
	}

	const kids: AccordionChild[] = children
		.filter((val) => 'topicset' in val)
		.map((val): AccordionChild => {
			const { attributes = {} as TopicAttrs, children = [] } = val.topicset;
			const { title, key } = attributes;
			keylocal.add(key);
			const keyset = new Set(expandKey || []);
			const [, , rootpath] = keymap.get(key)!.path.split('/');
			const data = keymap.get(rootpath);
			const roottitle = data ? data.title : '';
			const useEyebrow = title !== roottitle;

			const openbutton = v('span', { classes: [themeCss.openCloseIcon] }, [w(Icon, { faname: 'angle-down' })]);
			const closebutton = v('span', { classes: [themeCss.openCloseIcon] }, [w(Icon, { faname: 'angle-up' })]);
			const statusbar = v('span', { classes: [themeCss.status] }, [w('TopicStatusIcon', { key })]);
			const lockIcon = v('span', { classes: [themeCss.lockIcon] }, [w(Icon, { faname: 'lock' })]);
			const opentitle = v('div', { classes: [] }, [
				v('span', {}, [is_demo && allowed_topics.indexOf(key) === -1 ? lockIcon : null, title]),
				statusbar,
				closebutton
			]);
			const closedtitle = v('div', { classes: [] }, [
				v('span', {}, [is_demo && allowed_topics.indexOf(key) === -1 ? lockIcon : null, title]),
				statusbar,
				openbutton
			]);
			const eyebrow = useEyebrow ? v('span', { classes: [themeCss.eyebrow] }, [roottitle]) : null;
			const titleopen = v('div', {}, [eyebrow, opentitle]);
			const titleclosed = v('div', {}, [
				eyebrow,
				closedtitle,
				w(TopicsetShortdesc, { key, kids: children, isOpen: false })
			]);

			return {
				key,
				title: { open: titleopen, closed: titleclosed },
				content: w(TopicsetBody, { kids: children, key, isOpen: keyset.has(key) })
			};
		});

	return v('div', { classes: [themeCss.root], key, xqa: `topicaccordion ${key}` }, [
		w(
			Accordion,
			{
				openKeys: [...intersection(keybase, keylocal)],
				exclusive: true,
				headingLevel: 3,
				role: 'list',
				onOpenChanged: (keys) => {
					const { run } = lccstate;
					const keyset = [...difference(keybase, keylocal), ...Array.from(keys || [])];
					run(viewEditProcess)({ view: { params: { expandKey: keyset } } });
					run(tapaneChangeProcess)({ accordionSelected: keyset });
				}
			},
			kids
		)
	]);
});
